import { GetOnCourseDeviceAppDataQuery } from "../documents/device-data";

export const getDeviceDataQueryOptions = (isAuthenticated: boolean) => ({
  query: GetOnCourseDeviceAppDataQuery,
  pause: !isAuthenticated,
});
